import { Slugs } from 'common/urls/Slugs';
import { noop, size } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'src/shared/design-system/Dropdown';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { Container, DropdownWrapper, LinkWrapper, ShareButton, ShareButtonIcon } from './styles';
import { ShareDropdownButtonProps } from './types';

export const ShareDropdownButton: React.FC<ShareDropdownButtonProps> = ({ groupOrder: { canReviewOrder, orders } }) => {
  const { isSmallScreen } = useScreenContext();
  if (size(orders) > 1 || (canReviewOrder && !isSmallScreen)) {
    return null;
  }

  const { id, userId, shefId } = orders[0];
  const referPath = getSluggedPath(Routes.CONSUMER_ACCOUNT_SHARE_SHEF, [
    {
      slug: Slugs.SHEF_ID,
      value: shefId,
    },
  ]);

  const referOrderPath = getSluggedPath(Routes.CONSUMER_ACCOUNT_SHARE_ORDER, [
    {
      slug: Slugs.ID,
      value: userId,
    },
    {
      slug: Slugs.ORDER,
      value: id,
    },
  ]);

  const items = [
    {
      displayedText: (
        <LinkWrapper>
          <Link to={referPath}>Share Shef</Link>
        </LinkWrapper>
      ),
      value: 'shef',
    },
    {
      displayedText: (
        <LinkWrapper>
          <Link to={referOrderPath}>Share Order</Link>
        </LinkWrapper>
      ),
      value: 'order',
    },
  ];

  return (
    <Container onClick={(e) => e.preventDefault()}>
      <ShareButton>
        <ShareButtonIcon />
        Share
      </ShareButton>
      <DropdownWrapper>
        <Dropdown onChange={noop} items={items} showDropdownArrow={false} />
      </DropdownWrapper>
    </Container>
  );
};
